import { render, staticRenderFns } from "./HeaderHelpDialog.vue?vue&type=template&id=060878f9&scoped=true"
import script from "./HeaderHelpDialog.vue?vue&type=script&lang=js"
export * from "./HeaderHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./HeaderHelpDialog.vue?vue&type=style&index=0&id=060878f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060878f9",
  null
  
)

export default component.exports